// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"Tabs_tabButton__6YjoB","active":"Tabs_active__1yc7a","tabHeader":"Tabs_tabHeader__3y9B4"};